var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-primary","loading":_vm.isLoading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.save()}}},[_vm._v(" Speichern ")])
}
var staticRenderFns = []

export { render, staticRenderFns }